import axios from 'axios';
import { store } from './store.js';

const client = axios.create({
  timeout: 60000,
  headers: { 'Authorization': `Bearer ${store.token}` },
});

export function clearUnauthorizedSession() {
  if (typeof localStorage !== 'undefined' && typeof localStorage.removeItem === 'function') {
    localStorage.removeItem('userData');
  }
  store.token = '';
  store.client_id = '';
  store.user_id = '';
  store.name = '';
  store.trading_name = '';
  store.type_user = '';
  store.roles = [];
  if (typeof window !== 'undefined' && window.location && typeof window.location.reload === 'function') {
    window.location.reload();
  }
}

client.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response) {
      const requestUrl = (error.response.config && error.response.config.url) ? error.response.config.url : '';
      if (error.response.status === 401 && !requestUrl.includes('/auth')) {
        clearUnauthorizedSession();
      } else {
        const apiErrorMessage = error.response.data.message;
        return Promise.reject(apiErrorMessage);
      }
    } else if (error.request) {
      console.error('No response received from server.');
    } else {
      console.error('Error setting up the request:', error.message);
    }
    return Promise.reject(error);
  }
);

export default client;